'use strict';

import { hasSize } from '../lib/is-mobile';
import { setupClickDropdown, setupHoverDropdown, resizeLoginDropdown } from '../lib/dropdown';
import fixElementTop from './element-top';



/*
 * Setup dropdowns
 */
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(`
        .submenu.click,
        .mobile-menu .show-all-categories,
        .product-overview .content .show-all-categories,
        body.Brands .show-all-categories
    `)
    .forEach(setupClickDropdown);

    document.querySelectorAll('.submenu:not(.click)')
        .forEach(setupHoverDropdown);
});





/*
 * Open mobile nav and category list
 */
const mobileNavBtn = document.querySelectorAll('.toggle-mobile-nav, .mobile-nav .toggle');
const closeMobileNavBtn = document.querySelector('.close-mobile-nav-btn');
const activateAllProducts = document.querySelector('.activate-all-products');
const categoryList = document.querySelector('.show-all-categories');
const body = document.querySelector('body');
const mobileNav = document.querySelector('.mobile-nav');

if ( mobileNavBtn && mobileNav ) {
    mobileNavBtn
        .forEach(btn => btn.addEventListener('click', () => {
            mobileNav.classList.toggle('active');
            body.style.overflow =
                mobileNav.classList.contains('active')
                    ? 'hidden'
                    : 'initial';
            })
        );


    /*
     * Open mobile nav on product categories
     */
    const categoryLinks = document.querySelectorAll('a[href$="/productcategorieen"]');
    const hamburgerBtn = document.querySelector('.mobile-nav-btn');
    if ( categoryLinks ) {
        categoryLinks
            .forEach(link => link.addEventListener('click', evt => {
                if ( hasSize('md') ) {
                    evt.preventDefault();

                    hamburgerBtn.click();
                }
            }));
    }
}

if ( closeMobileNavBtn ) {
    closeMobileNavBtn.addEventListener('click', () => {
        body.classList.remove('mobile');
    });
}

if ( mobileNavBtn && activateAllProducts && categoryList ) {
    activateAllProducts.addEventListener('click', evt => {
        evt.stopPropagation();

        mobileNavBtn.click();
        categoryList.click();
    });
}





/*
 * Show full width dropdown on tablet
 */
const loginSubmenu = document.querySelector('.submenu.login');
const mainHeader = document.querySelector('.main-header');

if ( loginSubmenu ) {
    resizeLoginDropdown(loginSubmenu);
}
